<template>
    <ul class="form_list">
        <li class="title">
            {{ $t('reservation_settings.popup_staff_settings.label_appt_notification_account') }}
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">담당자에게 예약이 등록되거나 수정/취소 된 경우 알림을 받을 관리자 계정을 설정해 주세요.</span>
            </span>
        </li>
        <li class="cont">
            <div class="custom_select">
                <div class="input_s w_full" @click.stop="action_ShowList">
                    <span class="txt">{{ title }}</span>
                    <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
                </div>
                <!-- 위에 input_s 클릭하면 보이는 리스트 -->
                <div class="list multiple" style="max-height: 200px;" v-if="isShowList"
                     v-clickoutside:action_HideList="{}">
                    <div class="item">
                        <label class="check_wrap">
                            <input type="checkbox" v-model="isSelectAll" @change="action_SelectAll">
                            <span class="checkmark"></span>
                            <span class="txt ellipsis">{{ $t('reservation_settings.popup_staff_settings.label_appt_notification_account_all_accounts') }}</span>
                        </label>
                    </div>
                    <Item
                        v-for="(u, index) in refinedUser" :key="index"
                        :value="u"
                        @input="updateUser"
                    />
                </div>
            </div>
        </li>
    </ul>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import Item from './Items/NotificationUserItem.vue'

export default {
    components: { Item },
    props: {
        value: Array,
        users: Array,
        isShowList: Boolean
    },
    data() {
        return {

            isSelectAll: false,
            refinedUser: []
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function () {
                this.initRefinedUser()
            }
        },
        users: {
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.initRefinedUser()
            }
        },
        refinedUser: {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                let isSelectedAll = true
                for (let i = 0; i < newValue.length; i++) {
                    if (newValue[i].isSelected == false) { isSelectedAll = false }
                }
                this.isSelectAll = isSelectedAll
            }
        }
    },
    computed: {
        selectedUser: function () {
            return this.refinedUser.filter(u => u.isSelected == true)
        },
        title: function () {
            if (this.selectedUser.length == 0) { return this.$t('reservation_settings.popup_staff_settings.label_none') }
            if (this.selectedUser.length == this.users.length) { return this.$t('reservation_settings.popup_staff_settings.label_select_all') }
            let firstUserName = this.selectedUser[0].realName
            let tail = ''
            if (this.selectedUser.length > 1) {
                tail = '외 ' + (this.selectedUser.length - 1) + '명'
            }
            return firstUserName + tail
        }
    },
    methods: {
        // MARK: - 
        initRefinedUser() {
            if (this.value == undefined || this.users == undefined) { return }
            let selectedIDs = deepCopy(this.value)
            let refinedUser = deepCopy(this.users)
            refinedUser.forEach(u => {
                u.isSelected = false
                let target = selectedIDs.find(id => id == u._id)
                if (target != undefined) u.isSelected = true
            })
            this.refinedUser = refinedUser
        },

        updateUser(user) {
            let userID = user._id
            let target = this.refinedUser.find(u => u._id == userID)
            let index = this.refinedUser.indexOf(target)
            this.refinedUser.splice(index, 1, user)

            let selectedIDs = this.refinedUser.filter(u => u.isSelected == true)
            selectedIDs = selectedIDs.map(u => u._id)
            this.$emit('input', selectedIDs)
        },

        // MARK: - Actions
        action_ShowList() {
            this.$emit('updateVisible', { key: 'notification', value: !this.isShowList })
        },
        action_HideList() {
            this.$emit('updateVisible', { key: 'notification', value: false })
        },
        action_SelectAll() {
            this.refinedUser.forEach(u => u.isSelected = this.isSelectAll)
            this.$forceUpdate()
        },
    }
}
</script>